import {
  INTEGRATION_STATUS,
  type IntegrationStatusGroup,
  type IntegrationStatusItem,
} from './types';

export function groupIntegrations(
  items: IntegrationStatusItem[]
): IntegrationStatusGroup[] {
  const byIntegration = new Map<string, IntegrationStatusItem[]>();
  for (const item of items) {
    const key = `${item.applicationId}|${item.serviceId}`;
    const instances = byIntegration.get(key);
    if (instances) {
      instances.push(item);
    } else {
      byIntegration.set(key, [item]);
    }
  }

  return [...byIntegration.entries()].map(([key, instances]) => {
    const first = instances[0];
    const attentionInstances = instances.filter(
      (item) => item.status === INTEGRATION_STATUS.ACTION_REQUIRED
    );

    return {
      key,
      applicationId: first.applicationId,
      serviceId: first.serviceId,
      companyName: first.companyName,
      variantName: first.variantName,
      logo: first.logo,
      categoryKey: first.categoryKey,
      categoryLabel: first.categoryLabel,
      activationLabel: first.activationLabel,
      status:
        attentionInstances.length > 0
          ? INTEGRATION_STATUS.ACTION_REQUIRED
          : instances.some((item) => item.status === INTEGRATION_STATUS.ACTIVE)
            ? INTEGRATION_STATUS.ACTIVE
            : INTEGRATION_STATUS.INACTIVE,
      statusPending: instances.some((item) => item.statusPending),
      lastSyncAt: instances.reduce<string | null>(
        (latest, item) =>
          item.lastSyncAt && (!latest || item.lastSyncAt > latest)
            ? item.lastSyncAt
            : latest,
        null
      ),
      hasFailures: instances.some((item) => item.hasFailures),
      monitorUnavailable: instances.some((item) => item.monitorUnavailable),
      errors: [
        ...new Map(
          attentionInstances
            .flatMap((item) => item.errors)
            .map((error) => [error.title, error])
        ).values(),
      ],
      instances,
      attentionInstances,
    } satisfies IntegrationStatusGroup;
  });
}

export function getPrimaryInstance(
  group: IntegrationStatusGroup
): IntegrationStatusItem {
  return group.attentionInstances[0] ?? group.instances[0];
}
